import React from 'react';
import PropTypes, { string, array } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SchoolDataSimple.scss';

const SchoolDataSimple = ({ title, stat }) => (
  <div className={style.root}>
    <span className={style.title}>{title}</span>
    {Array.isArray(stat) ? ( // for arrays with strings, display a list:
      <ul>
        {stat.map(({ name }) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    ) : (
      <p>{stat}</p>
    )}
  </div>
);

SchoolDataSimple.propTypes = {
  title: PropTypes.string.isRequired,
  stat: PropTypes.oneOfType([string, array]).isRequired,
};

export default withStyles(style)(SchoolDataSimple);
